import {
  Button,
  Copy,
  Flex,
  Heading,
  Square,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { Modal } from 'src/components/Modal/Modal';

export interface OrderingPolicyDeactivationModalProps {
  onConfirm: (value: boolean) => void;
  onClose: () => void;
}

export function OrderingPolicyDeactivationModal({
  onConfirm,
  onClose,
}: OrderingPolicyDeactivationModalProps): JSX.Element {
  return (
    <Modal size="xs">
      <Square inset="x-sm">
        <Square inset="md">
          <Heading variant="h2">
            Are you sure you want to deactivate ordering policy?
          </Heading>
        </Square>
        <Square inset="md">
          <Copy variant="body" color="primaryText">
            Deactivating will remove the ordering policy setting for all
            ordering permissions
          </Copy>
        </Square>
        <Square inset="md">
          <Flex>
            <Stack x="md" width="50%">
              <Button
                variant="primary"
                onClick={(): void => {
                  onConfirm(false);
                }}
                buttonSize="medium"
                block
              >
                Deactivate
              </Button>
            </Stack>
            <Stack x="md" width="50%">
              <Button
                block
                variant="secondary"
                onClick={onClose}
                buttonSize="medium"
              >
                Cancel
              </Button>
            </Stack>
          </Flex>
        </Square>
      </Square>
    </Modal>
  );
}
